import React from 'react';
import { useSelector } from 'react-redux';
import { ROLE_VALUE } from '@src/constants';

const AccessControl = ({ roles = [], permissions = [], children, message }) => {
  const { account } = useSelector((state) => state.auth);

  const userRoles = account?.roles || [];
  const userPermissions = account?.permissions || [];

  // if having super admin role, allow access
  if (userRoles.includes(ROLE_VALUE.SUPER_ADMIN)) {
    return <>{children}</>;
  }

  // in the situation where both roles and permissions are provided
  // check if user has all required roles and permissions
  if (roles.length > 0 && permissions.length > 0) {
    const hasRole = roles.some((val) => userRoles.includes(val));
    const hasPermission = permissions.some((val) =>
      userPermissions.includes(val),
    );
    if (hasRole && hasPermission) {
      return <>{children}</>;
    }
    return message || null;
  }

  // in that case where only roles are provided
  // check if user has any of the required roles
  if (roles.length > 0) {
    const hasRole = roles.some((val) => userRoles.includes(val));
    if (hasRole) {
      return <>{children}</>;
    }
    return message || null;
  }

  // in that case where only permissions are provided
  // check if user has any of the required permissions
  if (permissions.length > 0) {
    const hasPermission = permissions.some((val) =>
      userPermissions.includes(val),
    );
    if (hasPermission) {
      return <>{children}</>;
    }
    return message || null;
  }

  // if no roles or permissions are provided, just render children
  return <>{children}</>;
};

export default AccessControl;
